export default "__VITE_ASSET__VQIBokGF__"